// extracted by mini-css-extract-plugin
export default {"button":"ux-quiz-module--button--jFH2z"};